export const AI_CHAT_CONSTANTS = {
    TOKEN_EXPIRY_HOURS: 1,
    TOKEN_EXPIRY_MS: 60 * 60 * 1000, // 1 hour
    AUTH_HEADER: 'Api-Token'
} as const

export const AI_CHAT_ERRORS = {
    RESOURCE_ALREADY_EXISTS: 400202
}
